(function() {
    'use strict';

    angular
        .module('liverunApp')
        .controller('RacePositionsDetailController', RacePositionsDetailController);

    RacePositionsDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'RacePositions', 'RunnerRaceResume'];

    function RacePositionsDetailController($scope, $rootScope, $stateParams, previousState, entity, RacePositions, RunnerRaceResume) {
        var vm = this;

        vm.racePositions = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('liverunApp:racePositionsUpdate', function(event, result) {
            vm.racePositions = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
